import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import {NestedTreeControl} from '@angular/cdk/tree';
import {FlatTreeControl} from '@angular/cdk/tree';
@Component({
  selector: 'app-mat-tree-sidebar',
  templateUrl: './mat-tree-sidebar.component.html',
  styleUrls: ['./mat-tree-sidebar.component.scss']
})
export class MatTreeSidebarComponent implements OnInit {
  selectedNode: any;
  @Output() SelectedEvent = new EventEmitter()
  @Input('sidebarData')
  set in(val: any) {
    this.selectedNode = val[0].equipmentId
    this.selectNode(val[0])
    this.dataSource.data = val;
  }
  treeControl = new NestedTreeControl<any>(node => node.children);
  dataSource = new MatTreeNestedDataSource<any>();
  constructor() { }
  selectNode(node){
    this.selectedNode = node.equipmentId
    this.SelectedEvent.emit(node)
  }
  hasChild = (_: number, node: any) => !!node.children && node.children.length > 0;
  ngOnInit(): void {
  }

}
